import React from 'react';

/**
 * ViewToggle
 * Switch between Kanban (grid) and Table views.
 */
const ViewToggle = ({ viewStyle, setViewStyle }) => {
  // This component is intentionally hidden across the project.
  return null;
};

export default ViewToggle;
